import React, {useState, useEffect, useContext} from "react";

import cx from "classnames";
import styles from "./teams.module.scss";
import { useDispatch } from "react-redux";
import { fetchTeamsDashboardReport, fetchTeamsLeaderboardReport, fetchTeamsLearnersReport, fetchTeamsLearningsReport, fetchTeamsMostEnrolledLearningsReport, fetchTeamsSkillReport } from "src/redux/actions/coaching/reports";
import DashboardMetrics from "./dashboard";
import LeaderboardReport from "./leaderboard";
import MostEnrolledReport from "./enrollments";
import LearnersReport from "./learners";
import LearningsReport from "./learnings";
import { MonthPicker } from "../monthPicker";
import SkillsReport from "./skills";
import { CourseReportContext, CourseReportContextProps } from "../../context";

const TeamsReport = () => {

  const dispatch = useDispatch();


  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [selectedMonth, setSelectedMonth] = useState(monthNames[new Date().getMonth()]);
  const [reportContext, setReportContext] = React.useState<CourseReportContextProps>({
    startDate: new Date(),
    endDate: new Date(),
  });


  const handleMonthSelect = (month) => {
    setSelectedMonth(month);
  };

  const getStartAndEndDate = (monthName) => {
    const currentYear = new Date().getFullYear();

    // Convert month name to month index (0-based)
    const monthIndex = new Date(`${monthName} 1, ${currentYear}`).getMonth();

    // Start date of the month
    const startDate = new Date(currentYear, monthIndex, 1);

    // End date of the month (last day)
    const endDate = new Date(currentYear, monthIndex + 1, 0);

    return {
      startDate: startDate,
      endDate: endDate,
    };
  };

  useEffect(() => {
    const { startDate, endDate } = getStartAndEndDate(selectedMonth);

    // Set the report context for start and end dates
    setReportContext({
      startDate: startDate,
      endDate: endDate,
    });

    const request = {
      page: 0,
      limit: 10,
      startDate: startDate,
      endDate: endDate,
    };

    dispatch(fetchTeamsDashboardReport(request));
    dispatch(fetchTeamsMostEnrolledLearningsReport(request));
    dispatch(fetchTeamsLearningsReport(request));
    dispatch(fetchTeamsLearnersReport(request));
    dispatch(fetchTeamsLeaderboardReport(request));
    dispatch(fetchTeamsSkillReport(request));
  }, [selectedMonth]);

  return (
    <CourseReportContext.Provider value={reportContext}>
      <div className={styles.container}>
        <MonthPicker selectedMonth={selectedMonth} onPick={handleMonthSelect} />
        <DashboardMetrics />
        <LeaderboardReport />
        <SkillsReport />
        <MostEnrolledReport />
        <LearnersReport />
        <LearningsReport />
      </div>
    </CourseReportContext.Provider>
  );
};

export default TeamsReport;
